import React from 'react'
import TrialHeaderPc from '../../public/trial_header_for_pc.png'
import TrialHeaderSp from '../../public/trial_header_for_sp.png'
import ReservationMoveButton from '../../components/ReservationMoveButton'
import { THRESHOLD_SP_WIDTH } from '../../utils/constants'

const TrialHeaderForAB = ({
  isCountdownActive,
}: {
  isCountdownActive?: boolean
}) => {
  return (
    <>
      <section
        className="mx-auto text-center bg-cover pt-0 pb-2.5 sm:pb-6"
        style={{
          backgroundColor: '#fff4f0',
          marginTop: isCountdownActive ? 44 : 0,
        }}
      >
        <div className="mb-2.5">
          <div className="relative inline-block w-full">
            <picture className="block w-full">
              <source
                media={`(max-width: ${THRESHOLD_SP_WIDTH}px)`}
                srcSet={TrialHeaderSp.src}
              />
              <img
                src={TrialHeaderPc.src}
                alt=""
                className="w-full h-auto max-w-full mx-auto"
              />
            </picture>
          </div>
        </div>

        <ReservationMoveButton
          moveToId="reservation-step-summary"
          isAB={true}
        />
      </section>
    </>
  )
}

export default TrialHeaderForAB
